import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import PropertyList from './PropertyList';
import PropertyMap from './PropertyMap';
import './Map.css';

const Map = ({ properties, filters, map, searchMap, handleMapClick, handleMapOver }) => (
    <div className='container'>
        <Helmet>
            <title>View All HPP Property Locations | Hudson Pacific Properties</title>
            <meta name="description" property="og:description" content="Our office portfolio features ideally located, custom designed workspaces for innovators and those who support them." />
        </Helmet>
        <div className='map-view'>
            <div className='properties-wrapper' id='property-list-component'>
                <PropertyList
                    properties={properties.filter(property => property.showMarker)}
                    filters={filters}
                    propertyId={map.propertyId}
                    handleMapClick={handleMapClick}
                />
            </div>
            <div className='map-wrapper'>
                <PropertyMap
                    properties={properties}
                    filters={filters}
                    map={map}
                    searchMap={searchMap}
                    handleMapClick={handleMapClick}
                    handleMapOver={handleMapOver}
                />
            </div>
        </div>
    </div>
);

Map.propTypes = {
    properties: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    map: PropTypes.object.isRequired,
    searchMap: PropTypes.func.isRequired,
    handleMapClick: PropTypes.func.isRequired,
    handleMapOver: PropTypes.func.isRequired,
};

export default Map;
